import { useEffect } from 'react';

import isEqual from 'lodash/isEqual';
import { useNavigate } from '@tanstack/react-router';
import { LANG_PROP_NAME, LangDto, resolveLocale } from '@skillarea/lib-shared';

import { getBrowserLocale, parseLangCookieFromDocument } from '../locale';

import { paramsExtract } from './paramsExtract';

const LangParams = new Set([LANG_PROP_NAME]);

export const LangSaver = ({
  cookiesStore,
  isLoggedIn,
  onLocaleChange,
}: {
  cookiesStore: {
    saveLang: (params: { body?: LangDto }) => Promise<unknown>;
  };
  isLoggedIn: boolean;
  onLocaleChange?: (locale: string) => void;
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    const extractedData = paramsExtract(LangParams, navigate);
    const queryLang = extractedData.lang;
    const browserLocale = getBrowserLocale();
    const langFromCookie = parseLangCookieFromDocument();

    const langData: LangDto = {
      current: queryLang || langFromCookie.current || '',
      locale: browserLocale,
    };

    const resolvedLocale = resolveLocale({
      queryLang,
      cookieLang: langData,
      browserLocale,
    });

    const shouldPersist = Boolean(queryLang) || !isLoggedIn;

    if (shouldPersist) {
      const mergedLang: LangDto = {
        current: queryLang || langFromCookie.current || resolvedLocale,
        locale: browserLocale,
      };

      if (!isEqual(langFromCookie, mergedLang)) {
        void cookiesStore.saveLang({ body: mergedLang }).then(() => {
          if (queryLang) {
            onLocaleChange?.(resolvedLocale);
          }
        });
        return;
      }
    }

    if (queryLang) {
      onLocaleChange?.(resolvedLocale);
    }
  }, [cookiesStore, isLoggedIn, navigate, onLocaleChange]);

  return null;
};
